__turbopack_context__.v({
  "bannedWarning": "combo-module-scss-module__hdNqUq__bannedWarning",
  "legalityTable": "combo-module-scss-module__hdNqUq__legalityTable",
  "previewedWarning": "combo-module-scss-module__hdNqUq__previewedWarning",
  "title": "combo-module-scss-module__hdNqUq__title",
});
